import React from "react";
import emotifyLogo from "../../../../../assets/images/emotify_logo.png";
import style from "./BitsDisabled.module.scss";

const BitsDisabled: React.FC = () => {
  return (
    <div className={style.bitsDisabled}>
      <div className={style.bitsDisabled__info}>
        <img className={style.bitsDisabled__image} src={emotifyLogo} />
        <h2 className={style.bitsDisabled__title}>Channel has disabled Bits usage.</h2>
        <p className={style.bitsDisabled__text}>Remind your favorite streamer to turn it on :)</p>
      </div>
      <div className={style.bitsDisabled__infobox}>
        <span className={style.bitsDisabled__infoboxTitle}>Where is this?</span>
        <div>{"In their Creator Dashboard -> Extensions -> My Extensions -> Installed -> Manage Permissions"}</div>
      </div>
    </div>
  );
};

export default BitsDisabled;
